<template>
  <span
    class="gw-score"
    :class="[`gw-score--${variant}`]"
    :style="style"
    :title="notes || undefined"
  >
    {{ formatted }}
  </span>
</template>

<script>
import { computed } from "@vue/composition-api";

import { SCORE_LEVELS, formatScore, getScoreLevel } from "../source-presentation";

export default {
  name: "ScorePill",
  props: {
    score: {
      type: [Number, String],
      default: null,
    },
    // "cell" for the table column, "badge" for the floating chip on a card.
    variant: {
      type: String,
      default: "cell",
      validator: (value) => ["cell", "badge"].includes(value),
    },
    // The LLM's rationale, surfaced as a tooltip.
    notes: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    const level = computed(() => getScoreLevel(props.score));

    return {
      formatted: computed(() => formatScore(props.score)),
      style: computed(() => {
        const { color, background } = SCORE_LEVELS[level.value];
        return { color, backgroundColor: background };
      }),
    };
  },
};
</script>

<style lang="scss" scoped>
.gw-score {
  display: inline-block;
  font-weight: 800;
  text-align: center;
  white-space: nowrap;
}

// Geometry differs from RmrSoftBadge on purpose: a fixed-width block keeps the
// score column optically aligned, where a pill would ragged-edge.
.gw-score--cell {
  min-width: 44px;
  padding: 6px 8px;
  border-radius: $rmr-radius-md;
  font-size: 13px;
}

.gw-score--badge {
  padding: 4px 10px;
  border-radius: $rmr-radius-pill;
  font-size: 12px;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.12);
}
</style>
